/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ProjectDtoEdgeModel, ProjectDtoEdgeModelType } from "./ProjectDtoEdgeModel"
import { ProjectDtoEdgeModelSelector } from "./ProjectDtoEdgeModel.base"
import { ProjectDtoModel, ProjectDtoModelType } from "./ProjectDtoModel"
import { ProjectDtoModelSelector } from "./ProjectDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  nodes: IObservableArray<ProjectDtoModelType>;
}

/**
 * ProjectPaginatedDtoBase
 * auto generated base class for the model ProjectPaginatedDtoModel.
 */
export const ProjectPaginatedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectPaginatedDto')
  .props({
    __typename: types.optional(types.literal("ProjectPaginatedDto"), "ProjectPaginatedDto"),
    edges: types.union(types.undefined, types.null, types.array(types.late((): any => ProjectDtoEdgeModel))),
    nodes: types.union(types.undefined, types.null, types.array(MSTGQLRef(types.late((): any => ProjectDtoModel)))),
    totalCount: types.union(types.undefined, types.integer),
    hasNextPage: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectPaginatedDtoModelSelector extends QueryBuilder {
  get totalCount() { return this.__attr(`totalCount`) }
  get hasNextPage() { return this.__attr(`hasNextPage`) }
  edges(builder: string | ProjectDtoEdgeModelSelector | ((selector: ProjectDtoEdgeModelSelector) => ProjectDtoEdgeModelSelector) | undefined) { return this.__child(`edges`, ProjectDtoEdgeModelSelector, builder) }
  nodes(builder: string | ProjectDtoModelSelector | ((selector: ProjectDtoModelSelector) => ProjectDtoModelSelector) | undefined) { return this.__child(`nodes`, ProjectDtoModelSelector, builder) }
}
export function selectFromProjectPaginatedDto() {
  return new ProjectPaginatedDtoModelSelector()
}

export const projectPaginatedDtoModelPrimitives = selectFromProjectPaginatedDto().totalCount.hasNextPage
